import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mai-waiting-video]',
  templateUrl: './waiting-video.html',
  host: {
    '[attr.viewBox]': 'viewbox()',
    class: 'h-15 md:h-20 lg:h-35 fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WaitingVideo {
  readonly viewbox = input<string>('0 0 218 142');
}
